import { Box, Icon } from '@hover/blueprint';
import { iExternalLink } from '@hover/icons';
import { Component as BlackHoverLogo } from '@hover/tokens-brand/assets/logo-mark--black.svg';
import React from 'react';

import { Link } from 'src/shared/components';
import type { LinkPressed } from 'src/shared/telemetry';

const RenderingPopoverHeader = ({
  visitWebsiteText,
  trackingProperties,
}: {
  visitWebsiteText: string;
  trackingProperties: Partial<LinkPressed>;
}) => (
  <Box
    alignItems="center"
    display="flex"
    flexDirection="row"
    justifyContent="space-between"
  >
    <Box height={300} width={300}>
      <BlackHoverLogo height="100%" width="100%" />
    </Box>
    <Box alignItems="center" flexDirection="row">
      <Link
        isExternal
        optionalTrackingProperties={trackingProperties}
        target="_blank"
        to="/"
      >
        {visitWebsiteText}
      </Link>
      <Icon color="primary.base" icon={iExternalLink} mx="2px" />
    </Box>
  </Box>
);
export { RenderingPopoverHeader };
